import styled from "@emotion/styled";

export const SupplierFilterTileWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 1.375rem;
`;
